import "./app-frontend.5e6cff43.js";
import "./app-frontend.8844f5bc.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2SsuL", function(module, exports) {
module.exports = import.meta.resolve("kMLYX");

});

parcelRegister("7oBZS", function(module, exports) {
module.exports = Promise.all([
    import("bTtXo"),
    import("dDqLB"),
    import("f6ltU")
]).then(()=>parcelRequire('3FFvx'));

});


var $ayMG0 = parcelRequire("ayMG0");

var $cA8mQ = parcelRequire("cA8mQ");

var $hta8F = parcelRequire("hta8F");

var $aRPiL = parcelRequire("aRPiL");

var $j1W2m = parcelRequire("j1W2m");

var $dtKoB = parcelRequire("dtKoB");

var $jW3HH = parcelRequire("jW3HH");

(0, $j1W2m).GlobalWorkerOptions.workerSrc = new URL((parcelRequire("2SsuL"))).toString();
const $38d6cc12cd11cfd3$var$errorLogger = (0, $jW3HH.default)("app:errors");
$cA8mQ.init({
    beforeSend: (event, hint)=>{
        const error = hint.originalException ?? hint.syntheticException ?? event.message;
        if (error) $38d6cc12cd11cfd3$var$errorLogger("%O", error);
        return event;
    },
    dsn: "https://7a39720e837da4dd86d7488c4b521aef@o73137.ingest.us.sentry.io/4512263967997952",
    environment: "production",
    maxValueLength: 2500,
    release: `helloscreen-frontend@${"2026.10.7"}`
});
window.reload = ()=>{
    sessionStorage.setItem("reload", "true");
    location.reload();
};

const $38d6cc12cd11cfd3$var$importApp = (parcelRequire("7oBZS"));
const $38d6cc12cd11cfd3$var$language = (0, $hta8F.default).get("upscope_locale") ?? navigator.language;
(0, $dtKoB.initI18n)($38d6cc12cd11cfd3$var$language).then(async ()=>{
    return $38d6cc12cd11cfd3$var$importApp;
}).then(({ App: App })=>{
    const root = (0, $aRPiL.createRoot)(document.querySelector("#root"));
    root.render(/*#__PURE__*/ (0, $ayMG0.jsx)(App, {}));
});


//# sourceMappingURL=app-frontend.306dda20.js.map
